import { IRoute } from "../interfaces/IRoute";
import Shell from "../screens/Shell";

const mainRoutes: IRoute[] = [
    {
        component: () => null,
        path: "/",
        exact: true
    },
    {
        component: Shell,
        path: "/app"
    }
];

export default mainRoutes;
